import classNames from "classnames";
import { ReactNode, useEffect, useMemo, useRef, useState } from "react";

import css from "./animated_content_switcher.module.scss";

type AnimatedContentSwitcherProps<T extends string> = {
  items: Partial<Record<T, ReactNode>>;
  active: T;
  className?: string;
};

export const AnimatedContentSwitcher = <T extends string>({
  items,
  active,
  className
}: AnimatedContentSwitcherProps<T>) => {
  const timeoutId = useRef<number | undefined>(undefined);
  const [visible, setVisible] = useState<boolean>(false);
  const page = useRef<T | undefined>(active);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const item = useMemo(() => items[page.current || (Object.keys(items)[0] as T)], [items, page.current]);

  useEffect(() => {
    setVisible(false);
    timeoutId.current = window.setTimeout(() => {
      page.current = active;
      setVisible(true);
    }, 100); // 100ms matches css animation duration
    return () => window.clearTimeout(timeoutId.current);
  }, [active]);

  return <div className={classNames(css.child, { [css.visible]: visible }, className)}>{item}</div>;
};
